// extracted by mini-css-extract-plugin
export default {"spanStyle":"print_spanStyle__Z6V0U","grid":"print_grid__K8lpU"};